import {
  Dialog, DialogActions, DialogContent, DialogTitle,
} from "@mui/material";
import { TabletButton } from "@components/tablet-button/custom-button";

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  content?: string;
}

export function ConfirmationDialog({
  open,
  onClose,
  onConfirm,
  title = "Confirm Action",
  content = "Are you sure want to perform this action ?",
}: ConfirmationDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <TabletButton
          className="formButton"
          onClick={() => {
            onConfirm();
            onClose();
          }}
          id="cad-simulator-confirm-button"
        >
          Confirm
        </TabletButton>
        <TabletButton
          className="formButton"
          onClick={onClose}
          id="cad-simulator-cancel-button"
        >
          Cancel
        </TabletButton>
      </DialogActions>
    </Dialog>
  );
}
